import axios from 'axios';
import { cachetime } from '../config';

export default function() {
  return {
    namespaced: true,
    state: {
      articles: {
        // category/slug -> data, __updatedAt
      },
    },
    mutations: {
      SET_ARTICLE(state, { category, slug, data, locale }) {
        if (state.articles[category] == undefined) {
          state.articles[category] = {};
        }

        if (state.articles[category][slug] == undefined) {
          state.articles[category][slug] = {};
        }

        state.articles[category][slug][locale] = {
          ...data,
          __updatedAt: Date.now()
        }
      },
    },
    actions: {
      FETCH_ARTICLE({ state, commit }, { category, slug, locale }) {
        const now = Date.now();
        if (state.articles[category] 
          && state.articles[category][slug]
          && state.articles[category][slug][locale]
          && state.articles[category][slug][locale].__updatedAt
          && now - state.articles[category][slug][locale].__updatedAt < cachetime
        ) return;

        return axios.get(encodeURI(`/api/article/${category}/${slug}`))
          .then((res) => {
            const data = res.data || {};

            commit('SET_ARTICLE', { category, slug, data, locale });
          }).catch(err => {
            // console.log(err);
            // if (err.response && err.response.status == 404) {
              throw err;
            // }
          });      
      },
    },
    getters: { 
      getArticle: (state) => (category, slug, locale) => {
        return (state.articles[category] 
          && state.articles[category][slug] 
          && state.articles[category][slug][locale]
        ) || {};
      },
    }
  }
}